import styled from 'styled-components';

const WrapSketchStep = styled.div`
  .ant-steps-item-description {
    font-size: 13px;
  }
`;

export { WrapSketchStep };



// WEBPACK FOOTER //
// ./src/components/sketchStep/index.styled.ts